import type { CustomerState, MenuItemId } from '../types';

export const CUSTOMER_VISUAL_IDS = [
  'aylin', 'cem', 'nermin', 'baran', 'derya', 'kemal', 'selin', 'mert', 'elif', 'ali',
] as const;

export type CustomerVisualId = typeof CUSTOMER_VISUAL_IDS[number];

export function customerVisualForSequence(sequence: number, dayId = 1): CustomerVisualId {
  return CUSTOMER_VISUAL_IDS[(sequence - 1 + (dayId - 1) * 3) % CUSTOMER_VISUAL_IDS.length];
}

export function visualStateForCustomer(
  state: CustomerState,
  item: MenuItemId,
  patienceRatio: number,
): string {
  if (state === 'ARRIVING') return 'arrive';
  if (state === 'WAITING_FOR_SEAT') return patienceRatio < 0.35 ? 'impatient' : 'queueIdle';
  if (state === 'WALKING_TO_TABLE') return 'walk';
  if (state === 'DECIDING') return 'deciding';
  if (state === 'WAITING_TO_ORDER') return patienceRatio < 0.35 ? 'impatient' : 'waitingForOrder';
  if (state === 'WAITING_FOR_FOOD') return patienceRatio < 0.35 ? 'impatient' : 'waitingForFood';
  if (state === 'EATING') return item === 'coffee' || item === 'tea' || item === 'lemonade' ? 'drinking' : 'eating';
  if (state === 'WAITING_TO_PAY') return 'payment';
  if (state === 'ANGRY_LEAVING') return 'angry';
  return 'leaving';
}

